import { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getEmpresas, PERFIL_ADMIN } from '../security/securityContext';
import { validaPerfis } from '../security/Autorizacao';
import { getEmpresaSelecionada } from '../util/empresaSelecionada';
import alterarEmpresaSelecionada from '../actions/empresa/alterarEmpresaSelecionada';

export class RedirectPagina extends Component {
  componentDidMount () {
    const empresas = getEmpresas();
    const empresaSelecionada = getEmpresaSelecionada();
    const temPefilAdmin = validaPerfis([PERFIL_ADMIN]);

    let naoFoiRecudoAutenticacaoDoisFatores = true;
    if (this.props.authentication && this.props.authentication.dataRecusaAutenticacaoDoisFatores != null) {
      const dataAtual = new Date()
      const dataLimite = new Date(this.props.authentication.dataRecusaAutenticacaoDoisFatores);
      naoFoiRecudoAutenticacaoDoisFatores = dataAtual > dataLimite
    }    

    if (temPefilAdmin) {      
      this.props.alterarEmpresaSelecionada(empresas[0])      
      if(this.props.history.location.state && this.props.history.location.state.from.pathname ==='/painel-vendas-geral') {
        this.props.history.push('/painel-vendas-geral')
      } else if(this.props.history.location.state && this.props.history.location.state.from.pathname ==='/painel-disponiveis-internet') {
        this.props.history.push('/painel-disponiveis-internet')
      } else {
        this.props.history.push('/gestao')
      }
      
    }else if(this.props.history.location.state && this.props.history.location.state.from.pathname ==='/painel-vendas-geral'){
      if (this.props.authentication.habilitadoAceiteAutenticacaoDoisFatores && naoFoiRecudoAutenticacaoDoisFatores && !this.props.authentication.habilitadoAutenticacaoDoisFatores) {
        this.props.history.push('/painel-mensagem-autenticacao-dois-fatores')
        return;
      }
      this.props.alterarEmpresaSelecionada(empresas[0])
        this.props.history.push('/painel-vendas-geral')
    } else {      
      if (this.props.authentication.habilitadoAceiteAutenticacaoDoisFatores && naoFoiRecudoAutenticacaoDoisFatores  && !this.props.authentication.habilitadoAutenticacaoDoisFatores) {
        this.props.history.push('/painel-mensagem-autenticacao-dois-fatores')
        return;
      }
      if (empresaSelecionada && empresaSelecionada.id) {        
        this.props.history.push('/gestao-empresa')
        return
      }
      if (empresas && empresas.length === 1) {        
        this.props.alterarEmpresaSelecionada(empresas[0])
        this.props.history.push('/gestao-empresa')
        return
      }

      if (empresas && empresas.length > 1 ) {
        this.props.history.push('/selecao-empresa')
      }
    }
  }

  render () {
    return ''
  }
}

export const mapStateToProps = state => ({
  authentication: state.authentication
})

export default withRouter(connect(mapStateToProps, { alterarEmpresaSelecionada })(RedirectPagina))
